






























import { Component, Vue, Prop, Mixins } from 'vue-property-decorator'
import { getApplyFeatureList } from '@/apps/open/services/app'
import { IPayData } from '@/apps/open/types/pay'
import Button from '@/apps/open/components/Button'
import AppKeySettiing from './AppKey.vue'
import IPWhitelistSetting from './IPWhitelist.vue'
import DomainWhitelistSetting from './DomainWhitelist.vue'
import CsrfWhitelistSetting from './CsrfWhitelistSetting.vue'
import PersonCallbackSetting from './PersonCallback.vue'
import corpAuthNotifySetting from './CorpAuthNotify.vue'
import InceptMsgAdress from './InceptMsgAdress.vue'
import PaySetting from './Pay.vue'
import DeveloperSetting from './Developer.vue'
import { onRequestError } from '@/apps/open/utils'

@Component({
  components: {
    Button,
    AppKeySettiing,
    IPWhitelistSetting,
    DomainWhitelistSetting,
    PersonCallbackSetting,
    corpAuthNotifySetting,
    PaySetting,
    DeveloperSetting,
    InceptMsgAdress,
    CsrfWhitelistSetting
  }
})
export default class AppSetting extends Vue {
  @Prop() vasInfo!: IPayData

  showCorpAuthNotifyUrl = false
  showInceptMsgAdress = false

  get appId () {
    return this.$route.params.id
  }

  get isPrivate () {
    return this.$store.getters['isPrivate']
  }

  get isPriDocMiddle () {
    return this.$store.getters['isPriDocMiddle']
  }

  async loadInfo () {
    const res = await getApplyFeatureList(this.appId)
    this.showCorpAuthNotifyUrl = res.data.object_array.some((i: any) => i.function_name === (this.isPrivate ? '企业授权' : '企业通讯录') && i.status === 1)
    this.showInceptMsgAdress = res.data.object_array.some((i: any) => i.function_name === '消息订阅' && i.status === 1)
  }

  async mounted () {
    try {
      // appifo 和 adminList 数据统一从这里获取，提供给子组件使用
      await Promise.all([
        this.loadInfo(),
        this.$store.dispatch('App/GET_APP_INFO', this.appId),
        this.$store.dispatch('Admin/GET_ADMIN_LIST')
      ])
    } catch (error) {
      onRequestError(error)
    }
  }
}
